<style src="./elements.css" scoped></style>

<template>
    <div class="bug-report-container">
      <h1 class="page-title">Open ticket</h1>
      <form @submit.prevent="submitTicket" class="ticket-form">
        <!-- Type dropdown -->
        <div class="form-group">
          <label for="type">Type*</label>
          <select id="type" v-model="type" required>
            <option disabled value="">Select ticket type</option>
            <option value="Bug">Bug</option>
            <option value="Feature">Feature</option>
            <option value="Feature">Design</option>
          </select>
        </div>
  
        <!-- Summary text field -->
        <div class="form-group">
          <label for="summary">Summary*</label>
          <input
            id="summary"
            type="text"
            v-model="summary"
            placeholder="Tell us in a sentence about your ticket"
            required
          />
        </div>
  
        <!-- Description (optional) -->
        <div class="form-group">
          <label for="description">Description (optional)</label>
          <textarea
            id="description"
            v-model="description"
            placeholder="Add more detail here"
          ></textarea>
        </div>
  
        <button type="submit" class="action-button" :disabled="loading">
          Submit ticket
        </button>
      </form>
  
      <!-- Error & success messages -->
      <div v-if="error" class="error-message">{{ error }}</div>
      <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
    </div>
  </template>
  
  <script>
  import BugReportLogic from "./BugReportLogic.js";
  
  export default {
    name: "BugReport",
    mixins: [BugReportLogic]
  };
  </script>
  
  <style scoped>
  .bug-report-container {
    max-width: 600px;
    padding: 45px;
    margin-bottom: 30px;
    border-radius: 30px;
    background-color: #fff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 4px #c9bf9b54;
    margin: 50px auto;
  }
  
  .page-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    margin-top: 0;
  }
  
  .ticket-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .form-group label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    font-family: "Courier Prime", monospace;
    font-weight: 400;
    font-style: normal;
    width: 100%;
    max-width: 570px;
    padding: 12px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 3px 2px #dacb9736;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #F8F7F3;
  }
  
  .error-message {
    margin-top: 1rem;
    color: #dc2626;
  }
  
  .success-message {
    margin-top: 1rem;
    color: #155724;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    padding: 0.5rem;
    border-radius: 6px;
    font-size: 0.95rem;
  }

  .action-button {
    width: 25%;
  }
  </style>
  